module.exports = __webpack_public_path__ + "img/11.c61842a0.png";